export default __webpack_public_path__ + "static/media/logo_navecuador.b05e1668.PNG";